export type ApplicantSchemaKeys = {
  applicantSection: SchemaKey;
  applicantType: SchemaKey;
  applicantCorporateSearch: SchemaKey;
  applicantName: SchemaKey;
  applicantNameKana: SchemaKey;
  applicantPostalCode: SchemaKey;
  applicantAddress: SchemaKey;
  applicantBirthDate: SchemaKey;
  applicantTradeName: SchemaKey;
  applicantTradeNameKana: SchemaKey;
  applicantCorporateNumber: SchemaKey;
  applicantRepresentativeName: SchemaKey;
  applicantPhoneNumber: SchemaKey;
  applicantEmail: SchemaKey;
  applicantContactPersonal: SchemaKey;
};

export type SchemaKey = {
  formSchemaJsonPath: string;
  id: string;
};

export const APPLICANT_SCHEMA_KEYS_TEXT = {
  applicantSchemaKeys: "申請者情報を指定するキー",
  applicantSection: "申請者の情報",
  applicantType: "申請者の種別",
  applicantCorporateSearch: "法人検索",
  applicantName: "名前",
  applicantNameKana: "名前（カナ）",
  applicantPostalCode: "郵便番号",
  applicantAddress: "住所 / 所在地",
  applicantBirthDate: "生年月日（西暦）",
  applicantTradeName: "屋号",
  applicantTradeNameKana: "屋号（カナ）",
  applicantCorporateNumber: "法人番号",
  applicantRepresentativeName: "法人代表者名",
  applicantPhoneNumber: "電話番号",
  applicantEmail: "メールアドレス",
  applicantContactPersonal: "連絡担当者名",
} as const;

export const isEmptyApplicantSchemaKeys = (
  applicantSchemaKeys: ApplicantSchemaKeys,
): boolean => {
  return Object.values(applicantSchemaKeys).every(isEmptySchemaKey);
};

export const isEmptySchemaKey = (schemaKey: SchemaKey): boolean => {
  return schemaKey.formSchemaJsonPath === "" && schemaKey.id === "";
};

// DefaultApplicantSchemaKeys は、従来のフォームスキーマで一般的だった申請者セクションに則った ApplicantSchemaKeys.
// テスト用途などであれば問題ないが、本来的には ProcedureDetail のプロパティを参照すべきなので、実ロジックでの利用は最小限に止めること。
export const DefaultApplicantSchemaKeys: ApplicantSchemaKeys = {
  applicantSection: {
    formSchemaJsonPath: "root.0",
    id: "applicantSection",
  },
  applicantType: {
    formSchemaJsonPath: "root.0.children.0",
    id: "applicantType",
  },
  applicantCorporateSearch: {
    formSchemaJsonPath: "root.0.children.1",
    id: "applicantCorporateSearch",
  },
  applicantName: {
    formSchemaJsonPath: "root.0.children.2",
    id: "applicantName",
  },
  applicantNameKana: {
    formSchemaJsonPath: "root.0.children.3",
    id: "applicantNameKana",
  },
  applicantPostalCode: {
    formSchemaJsonPath: "root.0.children.4",
    id: "applicantPostalCode",
  },
  applicantAddress: {
    formSchemaJsonPath: "root.0.children.5",
    id: "applicantAddress",
  },
  applicantBirthDate: {
    formSchemaJsonPath: "root.0.children.6",
    id: "applicantBirthDate",
  },
  applicantTradeName: {
    formSchemaJsonPath: "root.0.children.7",
    id: "applicantTradeName",
  },
  applicantTradeNameKana: {
    formSchemaJsonPath: "root.0.children.8",
    id: "applicantTradeNameKana",
  },
  applicantCorporateNumber: {
    formSchemaJsonPath: "root.0.children.9",
    id: "applicantCorporateNumber",
  },
  applicantRepresentativeName: {
    formSchemaJsonPath: "root.0.children.10",
    id: "applicantRepresentativeName",
  },
  applicantPhoneNumber: {
    formSchemaJsonPath: "root.0.children.11",
    id: "applicantPhoneNumber",
  },
  applicantEmail: {
    formSchemaJsonPath: "root.0.children.12",
    id: "applicantEmail",
  },
  applicantContactPersonal: {
    formSchemaJsonPath: "root.0.children.13",
    id: "applicantContactPersonal",
  },
};
